import { render } from "./LastedNews.vue?vue&type=template&id=4e4f9d3c"
import script from "./LastedNews.vue?vue&type=script&lang=js"
export * from "./LastedNews.vue?vue&type=script&lang=js"

import "./LastedNews.vue?vue&type=style&index=0&id=4e4f9d3c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__